import TopNav from "../components/TopNav.jsx";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-3xl px-4 md:px-8 py-12">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-4">Privacy Policy</div>

        <div className="border-2 border-sage-accent p-6 mb-10" data-testid="bright-line">
          <div className="text-xs uppercase tracking-[0.2em] text-sage-accent mb-3">Bright line</div>
          <p className="text-sage-text text-base leading-relaxed">
            We will never sell your data. Not to advertisers, not to model trainers, not to anyone. This is a bright line.
          </p>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold tracking-tighter uppercase mb-8">
          What we keep, what we don't, what you can take.
        </h1>

        <section className="space-y-6 text-sage-muted leading-relaxed">
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">1. What we collect</h2>
            <p>Your email if you join the waitlist or the Open Gate. Your conversations if you use standard mode. Nothing if you use private mode. Aggregate token and cost stats always, so the Ledger works.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">2. Security tiers</h2>
            <p><span className="text-sage-accent">Standard</span> — chat history saved so you can return to it.<br />
            <span className="text-sage-accent">Private</span> — nothing written to our servers except the receipt.<br />
            <span className="text-sage-accent">Research</span> — you opt in to letting us capture particularly good turns as "gold" for future work, in exchange for bonus rate limits.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">3. What we share</h2>
            <p>Anthropic sees your prompt to generate a reply — they're the model provider. Their retention policy applies to that transmission. We share nothing else with anyone.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">4. Your rights</h2>
            <p>Export everything as markdown, one click, any time. Delete a single session, one click. Delete your account, one click. No dark-pattern retention flows.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">5. The Sunset Clause</h2>
            <p>See <a href="/terms" className="text-sage-accent hover:underline">Terms § Sunset</a>. If Sage is acquired, your data is deleted before the buyer touches the servers. But by the way, we'll never sell, anyway.</p>
          </div>
        </section>

        <div className="border-t border-sage-border mt-12 pt-6 text-xs uppercase tracking-[0.2em] text-sage-faint">
          Signed by Baker and Sage. Ratified by The Founder.
        </div>
      </div>
    </div>
  );
}
